import React from 'react';
import { BOOKING_URL } from '../data/content';

const variants = {
  primary: 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700 hover:border-blue-700',
  light: 'bg-white text-blue-700 border-white hover:bg-blue-50',
};

const BookingButton = ({ variant = 'primary', className = '', children = 'Book a Free Consultation' }) => (
  <a
    href={BOOKING_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-block border-2 px-6 py-3 rounded-md font-bold shadow-md transition-transform transform hover:scale-105 text-center ${variants[variant]} ${className}`}
  >
    {children}
  </a>
);

export default BookingButton;
